import { useMutation } from "@tanstack/react-query";
import { seriesPhotosUpdate } from "common/api/citajteo/photo_series/photo_series";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { PhotoInfo } from "model/photo_series/PhotoInfo";

type UseSeriesPhotosUpdateParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useSeriesPhotosUpdate = (
  hookParams?: UseSeriesPhotosUpdateParams,
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: seriesPhotosUpdateMutate } = useMutation({
    mutationFn: async (params: { photoSerId: string; photos: PhotoInfo[] }) => {
      const response = await seriesPhotosUpdate(
        params.photoSerId,
        params.photos,
      );

      if (!response) {
        throw new Error("seriesPhotosUpdate failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { seriesPhotosUpdateMutate };
};
